import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ParagraphTag from "../../reusebale/Paragraph";
import db from "../../../db/index.json";
import PlanSection from "../profile-complete/plans";
import { useSelector } from "react-redux";
import * as AuthAction from "../../../store/actions/auth/AuthAction";
const PlanStatus = ({ onButtonClick }) => {
  const { completeProfileData } = db;
  const { userCompleteProfile } = useSelector((state) => state.auth);
  const [profielPercentage, setProfilePercentage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(AuthAction.LogoutAction());
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    if (userCompleteProfile) {
      let completedSections = 0;
      const totalSections = 2; // personalInformation, companyInformation

      if (userCompleteProfile.personalInformation) completedSections++;
      if (userCompleteProfile.companyInformation) completedSections++;

      const percentage = (completedSections / totalSections) * 100;
      setProfilePercentage(percentage);
    }
  }, [userCompleteProfile]);

  return (
    <div className="w-full h-full pt-4 relative">
      <button
        onClick={handleLogout}
        className="absolute top-4 right-4 flex items-center gap-2 px-4 py-2 font-popinsRegular text-sm rounded-lg transition-colors duration-200"
      >
        <img
          src="/assets/daashboard/logout-icon.png"
          alt="Logout"
          className="w-8 h-8"
        />
        <ParagraphTag
          content={'Logout'}
          classes="font-popinsSemiBold text-lg pl-3"
        />
      </button>

      <div>
        <ParagraphTag
          content={completeProfileData.complete}
          classes="text-darkColor font-popinsSemiBold text-xl"
        />
        <ParagraphTag
          content={completeProfileData.profileDesc}
          classes="text-[#686868] font-popinsRegular text-sm w-[45%] pt-1"
        />
        <div class="w-[100%] h-4 mb-4 bg-[#E6BF9F33] rounded-full dark:bg-[#E6BF9F33] mt-4">
          <div
            class="h-4 bg-themeColor rounded-full dark:bg-themeColor"
            style={{ width: `${profielPercentage}%` }}
          ></div>
        </div>
      </div>
      <PlanSection onButtonClick={onButtonClick} />
    </div>
  );
};

export default PlanStatus;
